import { TooltipTrigger } from '@radix-ui/react-tooltip'
import type { PropsWithChildren } from 'react'
import type { FAIconProps } from './fa-icon'
import { FAIcon } from './fa-icon'
import { Tooltip, TooltipContent } from './ui/tooltip'
import { ZIndexRange } from '@/types/style'

interface Props extends PropsWithChildren {
  triggerClassName?: string
  contentClassName?: string

  icon?: FAIconProps['icon'] | FAIconProps
  side?: 'top' | 'right' | 'bottom' | 'left'
}

export function IconTooltip({
  children,

  triggerClassName,
  contentClassName,

  icon = { icon: 'info-circle', type: 'regular' },
  side,
}: Props) {
  const iconProps: FAIconProps = typeof icon === 'object' ? icon : { icon }

  return (
    <Tooltip>
      <TooltipTrigger className={triggerClassName} type="button">
        <FAIcon {...iconProps} />
      </TooltipTrigger>

      <TooltipContent
        className={contentClassName}
        side={side}
        style={{ zIndex: ZIndexRange.Extra }}
      >
        {children}
      </TooltipContent>
    </Tooltip>
  )
}
